var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteEntryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 12.25C1.5 12.6478 1.65804 13.0294 1.93934 13.3107C2.22064 13.592 2.60218 13.75 3 13.75H9C9.39782 13.75 9.77936 13.592 10.0607 13.3107C10.342 13.0294 10.5 12.6478 10.5 12.25V3.25H1.5V12.25ZM3 4.75H9V12.25H3V4.75ZM8.625 1L7.875 0.25H4.125L3.375 1H0.75V2.5H11.25V1H8.625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteEntryIcon);
export default __webpack_public_path__ + "static/media/delete-entry-icon.ca8f1bc5.svg";
export { ForwardRef as ReactComponent };